import type { CMSData } from '../types/cms';

export const defaultCMSData: CMSData = {
  hero: {
    badge: 'Nutricionista Certificado',
    title1: 'Transforma tu',
    title2: 'Salud con',
    title3: 'Nutrición Real',
    subtitle: 'Planes personalizados basados en ciencia para que alcances tus metas de bienestar de forma sostenible y sin dietas extremas.',
    ctaText: 'Pedir Cita',
    stat1Value: '500+',
    stat1Label: 'Pacientes Satisfechos',
    stat2Value: '8+',
    stat2Label: 'Años de Experiencia',
    nutritionistName: 'Lic. Dario Rojas',
    credentials: 'Nutricionista & Dietista Clínico',
    availability: 'Disponible · Buenos Aires',
    secondaryCtaText: 'Ver servicios',
    scrollHintText: 'Conocer más',
  },
  profile: {
    label: 'SOBRE MÍ',
    title1: 'Mi misión es tu',
    title2: 'bienestar duradero',
    description: 'Soy Dario Rojas, Licenciado en Nutrición y Dietética con más de 8 años de experiencia ayudando a personas a transformar su relación con la comida. Me especializo en planes personalizados que se adaptan a tu estilo de vida, preferencias y objetivos de salud. Creo que la alimentación saludable no debe ser complicada ni restrictiva — debe ser disfrutable, sostenible y adaptada a tu historia.',
    ctaText: 'Conocer más',
  },
  services: {
    label: 'SERVICIOS',
    title: 'Todo lo que necesitas para tu salud',
    subtitle: 'Programas diseñados para cada etapa de tu camino hacia el bienestar',
    items: [
      {
        id: 'svc_1',
        title: 'Consulta Nutricional Inicial',
        description: 'Evaluación completa de tu estado nutricional actual, historial médico y objetivos personales. El punto de partida para tu transformación.',
        duration: '60 minutos',
        price: '$3.500',
        featured: true,
      },
      {
        id: 'svc_2',
        title: 'Plan Alimentario Personalizado',
        description: 'Diseño de un plan de alimentación 100% adaptado a tus metas, preferencias y rutina diaria.',
        duration: '45 minutos',
        price: '$4.200',
        featured: false,
      },
      {
        id: 'svc_3',
        title: 'Seguimiento Mensual',
        description: 'Control y ajuste de tu progreso con revisión de métricas, ajuste del plan y resolución de dudas.',
        duration: '30 minutos',
        price: '$2.800',
        featured: false,
      },
      {
        id: 'svc_4',
        title: 'Nutrición Deportiva',
        description: 'Optimiza tu rendimiento y recuperación con estrategias nutricionales diseñadas para atletas y deportistas.',
        duration: '60 minutos',
        price: '$4.500',
        featured: false,
      },
    ],
  },
  testimonials: {
    label: 'TESTIMONIOS',
    heading: 'Lo que dicen mis pacientes',
    items: [
      {
        id: 'tst_1',
        text: 'Dario cambió completamente mi perspectiva sobre la alimentación. Bajé 12 kg sin sentir que estaba a dieta y hoy me siento con más energía que nunca.',
        name: 'Valeria Romero',
        role: 'Maestra, 34 años',
        stars: 5,
      },
      {
        id: 'tst_2',
        text: 'Después de años de dietas fallidas, el enfoque personalizado de Dario fue la diferencia. Aprendí a comer bien sin sacrificar lo que amo.',
        name: 'Martín Álvarez',
        role: 'Ingeniero, 41 años',
        stars: 5,
      },
      {
        id: 'tst_3',
        text: 'El seguimiento mensual es increíble. Dario está siempre disponible y sus consejos son prácticos y reales. Lo recomiendo al 100%.',
        name: 'Laura Fernández',
        role: 'Emprendedora, 28 años',
        stars: 5,
      },
    ],
  },
  contact: {
    title: 'RESERVA TU CITA',
    subtitle: 'Da el primer paso hacia una vida más saludable. Completa el formulario y me pondré en contacto contigo en menos de 24 horas.',
  },
  calendly: {
    badge: 'Agenda online',
    title: 'RESERVA TU CITA',
    subtitle: 'Elige el día y la hora que mejor te venga. Confirmación inmediata en tu email.',
  },
  footer: {
    description: 'Nutricionista clínico certificado con más de 8 años ayudando a personas a alcanzar sus metas de salud a través de planes personalizados y sostenibles.',
    email: 'dariorojasnutricion@gmail.com',
    phone: '+34 685 54 67 38',
    schedule: 'Lun – Vie: 9:00 – 18:00',
    copyright: '© 2026 Lic. Darío Rojas — Todos los derechos reservados',
  },
  seo: {
    homeFaqTitle: 'Preguntas frecuentes sobre nutricion',
    homeFaqQ1: '¿Atiendes en Palma de Mallorca o también online?',
    homeFaqA1:
      'Atiendo en Palma de Mallorca y tambien en formato online para pacientes que prefieren seguimiento a distancia.',
    homeFaqQ2: '¿Me puedes ayudar a adelgazar sin dietas extremas?',
    homeFaqA2:
      'Si. El objetivo es adelgazar de forma sostenible con un plan adaptado a tu rutina, gustos y objetivos de salud.',
    homeFaqQ3: '¿Ofreces planes de nutricion deportiva?',
    homeFaqA3:
      'Si, trabajo nutricion deportiva para mejorar rendimiento, recuperacion y composicion corporal.',
    homeFaqQ4: '¿Cuanto dura una consulta y que incluye?',
    homeFaqA4:
      'La primera consulta suele durar 60 minutos e incluye evaluacion completa, objetivos y estrategia nutricional personalizada.',
    seoFaqTitle: 'Preguntas frecuentes',
    seoFaqQ1: 'Cuanto dura la primera consulta de nutricion en Palma?',
    seoFaqA1: 'La primera consulta suele durar entre 45 y 60 minutos, segun tu caso y objetivos.',
    seoFaqQ2: 'Ofreces seguimiento despues de la evaluacion inicial?',
    seoFaqA2: 'Si. El seguimiento es clave para ajustar el plan, resolver dudas y consolidar resultados.',
    seoFaqQ3: 'Atiendes de forma presencial u online?',
    seoFaqA3: 'Atiendo en Palma de Mallorca y tambien en formato online para mayor flexibilidad.',
    seoMoreInfoTitle: 'Mas informacion',
    seoLink1: 'Nutricionista Palma',
    seoLink2: 'Nutricionista en Palma de Mallorca',
    seoLink3: 'Dietista en Palma de Mallorca',
    seoLink4: 'Nutricionista clinico en Palma',
    seoLink5: 'Adelgazar en Palma de Mallorca',
    seoLink6: 'Nutricion deportiva en Palma',
    footerLinksTitle: 'Enlaces de interes',
    footerLink1: 'Nutricionista Palma',
    footerLink2: 'Dietista en Palma',
    footerLink3: 'Nutricionista clinico en Palma',
    footerLink4: 'Adelgazar en Palma',
    footerLink5: 'Nutricion deportiva en Palma',
  },
  mobile: {},
};

export const defaultImages: Record<string, string> = {
  hero_photo: 'https://readdy.ai/api/search-image?query=professional%20male%20nutritionist%20in%20his%2030s%20wearing%20clean%20white%20medical%20coat%20standing%20confidently%20in%20modern%20wellness%20clinic%20natural%20window%20lighting%20warm%20shadows%20green%20plants%20background%20friendly%20professional%20smile%20close%20up%20portrait%20waist%20up%20photorealistic%20health%20wellness%20atmosphere&width=600&height=750&seq=hero_nutri_v1&orientation=portrait',
  profile_photo: 'https://readdy.ai/api/search-image?query=male%20nutritionist%20in%20his%2030s%20sitting%20at%20wooden%20desk%20reviewing%20food%20nutrition%20charts%20healthy%20meal%20plans%20surrounded%20by%20colorful%20vegetables%20fruits%20natural%20daylight%20from%20window%20warm%20beige%20green%20tones%20consultorio%20setting%20professional%20photography%20editorial%20style&width=700&height=600&seq=profile_nutri_v1&orientation=landscape',
  service_svc_1: 'https://readdy.ai/api/search-image?query=beautiful%20overhead%20flat%20lay%20fresh%20colorful%20vegetables%20fruits%20healthy%20superfoods%20arranged%20artfully%20on%20white%20marble%20background%20bright%20natural%20light%20clean%20minimalist%20composition%20nutritious%20meal%20planning%20concept%20vibrant%20greens%20reds%20yellows%20oranges%20food%20photography&width=500&height=400&seq=service_nutri_1&orientation=landscape',
  service_svc_2: 'https://readdy.ai/api/search-image?query=personal%20nutrition%20plan%20documents%20food%20diary%20meal%20prep%20containers%20healthy%20food%20wooden%20desk%20background%20warm%20lighting%20organized%20professional%20top%20down%20perspective%20clean%20aesthetic%20meal%20planning%20concept&width=500&height=400&seq=service_nutri_2&orientation=landscape',
  service_svc_3: 'https://readdy.ai/api/search-image?query=nutritionist%20consulting%20with%20patient%20at%20desk%20in%20modern%20clinic%20warm%20professional%20atmosphere%20tablet%20with%20health%20charts%20visible%20both%20engaged%20in%20discussion%20natural%20light%20positive%20health%20outcome%20feeling%20professional%20photography&width=500&height=400&seq=service_nutri_3&orientation=landscape',
  service_svc_4: 'https://readdy.ai/api/search-image?query=sports%20nutrition%20concept%20protein%20foods%20salmon%20eggs%20nuts%20quinoa%20arranged%20beautifully%20on%20dark%20slate%20background%20athletic%20lifestyle%20photography%20high%20performance%20food%20choices%20professional%20food%20styling&width=500&height=400&seq=service_nutri_4&orientation=landscape',
  contact_bg: 'https://readdy.ai/api/search-image?query=overhead%20view%20beautiful%20healthy%20meal%20spread%20colorful%20vegetables%20grains%20fresh%20ingredients%20on%20clean%20white%20surface%20bright%20natural%20lighting%20food%20photography%20editorial%20style%20vibrant%20colors%20nutritious%20and%20appetizing%20Mediterranean%20style&width=1400&height=800&seq=contact_bg_v1&orientation=landscape',
  testimonial_tst_1: 'https://readdy.ai/api/search-image?query=professional%20headshot%20happy%20latin%20woman%20in%20her%2030s%20warm%20genuine%20smile%20natural%20soft%20background%20studio%20lighting%20clean%20portrait%20photography%20health%20and%20wellness%20look%20positive%20energy&width=300&height=300&seq=test_nutri_1&orientation=squarish',
  testimonial_tst_2: 'https://readdy.ai/api/search-image?query=professional%20headshot%20satisfied%20latin%20man%20in%20his%2040s%20friendly%20confident%20smile%20business%20casual%20soft%20natural%20lighting%20portrait%20photography%20trustworthy%20appearance%20warm%20tones&width=300&height=300&seq=test_nutri_2&orientation=squarish',
  testimonial_tst_3: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20latin%20woman%20in%20her%2020s%20bright%20radiant%20smile%20healthy%20appearance%20natural%20light%20portrait%20photography%20fresh%20energetic%20look%20soft%20bokeh%20background&width=300&height=300&seq=test_nutri_3&orientation=squarish',
};
